export enum AppSubdomain {
    skillsManager = 'manage',
    accounts = 'account-settings',
    devCenter = 'devcenter',
    earn = 'earn',
    gamificationAdmin = 'gamification-admin',
    profiles = 'profiles',
    tcAcademy = 'academy',
    onboarding = 'onboarding',
    work = 'work',
    talentSearch = 'talent-search',
    wallet = 'wallet',
    walletAdmin = 'wallet-admin',
    copilots = 'copilots',
    admin = 'system-admin',
    review = 'review',
}

export enum ToolTitle {
    skillsManager = 'Manage Skills',
    accounts = 'Account Settings',
    devCenter = 'Dev Center',
    earn = 'Opportunity Feed',
    gamificationAdmin = 'Gamification Admin',
    profiles = 'Profiles',
    tcAcademy = 'Topcoder Academy',
    selfService = 'Self Service Challenges',
    onboarding = ' ',
    talentSearch = 'Expert Talent',
    wallet = 'Wallet',
    walletAdmin = 'Wallet Admin',
    copilots = 'Copilots',
    admin = 'Admin',
    review = 'Review',
}

export const PageSubheaderPortalId: string = 'page-subheader-portal-el'
